import { useQuery } from "react-query";
import styled from "styled-components";
import {
  getMovie,
  getNowPlayingMovies,
  getTopRatedMovies,
  getUpcomingMovies,
  IGetMoviesResult,
} from "../api/movies";
import { useEffect, useState } from "react";
import MovieSlider from "../Components/MovieSlider";
import Banner from "../Components/Banner";
import { useHistory, useRouteMatch } from "react-router-dom";
import MovieModal from "../Components/MovieModal";

const Wrapper = styled.div`
  background: transparent;
  padding-bottom: 200px;
`;

const Loader = styled.div`
  height: 20vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Sliders = styled.div``;

function Home() {
  const history = useHistory();
  const movieMatch = useRouteMatch<{ movieId: string }>("/movie/:movieId");
  const [selectedMovieId, setSelectedMovieId] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data, isLoading } = useQuery<IGetMoviesResult>({
    queryKey: ["movies", "nowPlaying"],
    queryFn: () => getNowPlayingMovies(),
  });

  const { data: movieData, isLoading: movieIsLoading } = useQuery({
    queryKey: ["movie", movieMatch?.params.movieId],
    queryFn: () => {
      const result = getMovie(Number(movieMatch?.params.movieId));
      return result;
    },
    enabled: typeof movieMatch?.params.movieId === "string",
  });

  const onOverlayClick = () => {
    if (selectedMovieId) setSelectedMovieId(null);
    setIsModalOpen(false);
    history.push("/");
  };

  useEffect(() => {
    if (movieMatch) setIsModalOpen(true);
  }, [movieMatch]);

  return (
    <Wrapper>
      {isLoading ? (
        <Loader>Loading...</Loader>
      ) : (
        <>
          <Banner
            id={data?.results[0].id!}
            category="movie"
            setMediaId={setSelectedMovieId}
            imagePath={data?.results[0].backdrop_path || ""}
            title={data?.results[0].title || "N/A"}
            overview={data?.results[0].overview || "N/A"}
          />
          <Sliders>
            <MovieSlider
              title="Now Playing"
              setSelectedMovieId={setSelectedMovieId}
              queryFn={getNowPlayingMovies}
              queryKey={["movies", "nowPlaying"]}
              isPartOfBanner={true}
            />
            <MovieSlider
              title="Top Rated"
              setSelectedMovieId={setSelectedMovieId}
              queryFn={getTopRatedMovies}
              queryKey={["movies", "topRated"]}
            />
            <MovieSlider
              title="Upcoming"
              setSelectedMovieId={setSelectedMovieId}
              queryFn={getUpcomingMovies}
              queryKey={["movies", "upcoming"]}
            />
          </Sliders>
          <MovieModal
            movieMatch={movieMatch}
            onOverlayClick={onOverlayClick}
            selectedMovieId={selectedMovieId}
            data={movieData}
            isLoading={movieIsLoading}
          />
        </>
      )}
    </Wrapper>
  );
}
export default Home;
